import axios from "axios";
import { finishAnonymousHolterUploadV2 } from "../api";
import { AnonymousHolterUploader } from "./AnonymousHolterUploader";

export class GcsResumableHolterUploader extends AnonymousHolterUploader {
  async upload() {
    const uploadUrl = this.initData.upload_url || this.initData.upload_id;

    if (!uploadUrl) {
      throw new Error("GCS resumable upload URL is missing");
    }

    for (let index = 0; index < this.chunks.length; index++) {
      const chunk = this.chunks[index];

      await this.uploadWithRetry(() =>
        axios.put(uploadUrl, chunk.blob, {
          headers: {
            "Content-Type": "application/octet-stream",
            "Content-Range": `bytes ${chunk.start}-${chunk.end - 1}/${this.options.file.size}`,
          },
          validateStatus: (status) => [200, 201, 308].includes(status),
        })
      );

      this.reportProgress(index);
    }

    return await finishAnonymousHolterUploadV2({
      serialNumber: this.options.serialNumber,
      sharableCode: this.options.sharableCode,
      measurementId: this.options.measurementId,
      uploadId: uploadUrl,
      fileSize: this.options.file.size,
    });
  }
}
